import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white py-12 px-4" data-testid="site-footer">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div>
            <h3 className="text-lg font-semibold mb-4">Medical Certificate Generator</h3>
            <p className="text-gray-400 text-sm">
              Free online tool to generate professional medical certificate templates. 100% free, no signup required.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Tool</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="text-gray-400 hover:text-white transition-colors" data-testid="footer-link-home">Home</Link></li>
              <li><Link to="/#generator" className="text-gray-400 hover:text-white transition-colors" data-testid="footer-link-generator">Generator</Link></li>
              <li><a href="/#faq" className="text-gray-400 hover:text-white transition-colors" data-testid="footer-link-faq">FAQ</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Resources</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/blog" className="text-gray-400 hover:text-white transition-colors" data-testid="footer-link-blog">Blog</Link></li>
              <li><Link to="/govt-guides" className="text-gray-400 hover:text-white transition-colors" data-testid="footer-link-govt">Govt Guides</Link></li>
              <li><Link to="/blog/what-is-medical-certificate" className="text-gray-400 hover:text-white transition-colors">What is a medical certificate?</Link></li>
              <li><Link to="/govt-guides/cghs-central-government-health-scheme" className="text-gray-400 hover:text-white transition-colors">CGHS guide</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Certificate Types</h3>
            <ul className="space-y-2 text-sm">
              <li className="text-gray-400">Sick Leave Certificate</li>
              <li className="text-gray-400">Medical Fitness Certificate</li>
              <li className="text-gray-400">General Medical Certificate</li>
              <li className="text-gray-400">Doctor Prescription</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="text-center">
            <p className="text-gray-400 text-sm">
              © {currentYear} Medical Certificate Generator. All rights reserved.
            </p>
          </div>
        </div>

        <div className="mt-8 p-4 bg-gray-800 rounded-lg">
          <p className="text-xs text-gray-400 text-center">
            <strong className="text-yellow-400">⚠️ IMPORTANT DISCLAIMER:</strong> All certificates generated are <strong>TEMPLATES ONLY</strong>. 
            They are not valid medical certificates without a licensed doctor&apos;s signature and official stamp. 
            This tool is for educational, demonstration, and drafting purposes only. 
            Misuse of these templates for fraudulent purposes is illegal.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
